import {ReactNode} from "react";
import {useNavigate} from "react-router-dom";
import {BounceLogo} from "@bounce/shared/ui/assets";
import {Container} from "../components";
import {colors, radii, shadows, spacing} from "../theme";
import {IconMessageBubble, IconHamburger} from "~/assets";
import {urls} from "~/routes/consumerUrls";

type NavBarProps = {
  logo?: ReactNode;
  onChatClick?: () => void;
  onMenuClick?: () => void;
};

const IconCircle = ({onClick, children}: {onClick?: () => void; children: ReactNode}) => (
  <Container
    center
    onClick={onClick}
    sx={{
      backgroundColor: colors.grey[100],
      border: `1px solid ${colors.grey[200]}`,
      borderRadius: radii.pill,
      padding: spacing[2],
      cursor: onClick ? "pointer" : "default",
    }}
  >
    {children}
  </Container>
);

const DefaultLogo = () => <BounceLogo color={colors.primary[800]} width="100px" height="21px" />;

export const NavBar = ({logo = <DefaultLogo />, onChatClick, onMenuClick}: NavBarProps) => {
  const navigate = useNavigate();

  return (
    <Container sx={{p: `${spacing[4]} ${spacing[3]}`, width: "100%"}}>
      <Container
        row
        center
        gap={0}
        sx={{
          backgroundColor: colors.white,
          border: `1px solid ${colors.tertiary[200]}`,
          borderRadius: radii.pill,
          p: `${spacing[3]} ${spacing[4]}`,
          justifyContent: "space-between",
          filter: `drop-shadow(${shadows.navBar})`,
        }}
      >
        <Container
          row
          center
          gap={0}
          onClick={() => navigate(urls.accounts.url)}
          sx={{position: "relative", left: 4, top: -3}}
        >
          {logo}
        </Container>
        <Container row center gap={2}>
          <IconCircle onClick={onChatClick}>
            <IconMessageBubble />
          </IconCircle>
          <IconCircle onClick={onMenuClick}>
            <IconHamburger />
          </IconCircle>
        </Container>
      </Container>
    </Container>
  );
};
